import React from "react";
import Page from "../Components/Page";
import DeviceList from "../features/devices/DeviceList";
import useFetchData from "../hooks/useFetchData";
import { IDevice } from "../features/devices/types";
import { useTranslation } from "react-i18next";

export default function DevicesPage() {
  const { data: devices, isLoading } = useFetchData<IDevice[]>("/devices");
  const { t } = useTranslation();

  return (
    <Page title={t("Devices")} isLoading={isLoading}>
      {devices && <DeviceList devices={devices} />}
    </Page>
  );
}
